import Vue from 'vue'

Vue.filter('prettyProofFeedback', (type: String) => {
  if (!type) return null
  return type.replace('_', ' ').replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
})
